import React, { useState, useEffect } from "react";
import "./DriverForm.css";

// components imports
import Loader from "../../../../../Components/CircularLoader/CircularLoader";

// apis imports
import {
  createNewDriver,
  editDriver,
} from "../../../../../services/drivers.services";
import { fetchAllVehicles } from "../../../../../services/vehicles.services";

// library imports
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Autocomplete from "@mui/material/Autocomplete";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Upload from "@mui/icons-material/CloudUpload";
import { FaPlus } from "react-icons/fa";
import VehicleForm from "../../../Vehicles/Components/VehicleForm/VehicleForm";
import { useDispatch } from "react-redux";
import { showSnackBar } from "../../../../../store/common/snackBarSlice";
import { useTranslation } from "react-i18next";

const initialData = {
  username: "",
  name: "",
  email: "",
  phone: "",
  start_time: "",
  end_time: "",
  vehicle: "",
  picture: null,
  password: "",
};

export default function DriverForm({ open, setOpen, setRefresh }) {
  const { t } = useTranslation("carrier");
  const [data, setData] = useState(initialData);
  const [confirmPassword, setConfirmPassword] = useState("");

  const [vehicles, setVehicles] = useState([]);

  const [loading, setLoading] = useState(false);
  const [addVehicleModal, setAddVehicleModal] = useState();

  const dispatch = useDispatch();

  const handleClose = () => {
    setData(initialData);
    setOpen(false);
  };

  const getAllVehicles = async (page, perPage, filter) => {
    const response = await fetchAllVehicles(page, perPage, filter);
    if (!response.error) {
      setVehicles(response?.data?.result?.data);
    } else {
      dispatch(
        showSnackBar({
          text: t("common:messages.somethingWentWrong"),
          severity: "error",
        })
      );
    }
  };

  useEffect(() => {
    getAllVehicles("1", "100", "");
    if (open?.id) {
      setData({
        id: open?.id ?? "",
        username: open?.driver?.username ?? "",
        name: open?.driver?.name ?? "",
        email: open?.driver?.email ?? "",
        phone: open?.driver?.phone ?? "",
        start_time: open?.driver?.start_time ?? "",
        end_time: open?.driver?.end_time ?? "",
        vehicle: open?.driver?.vehicle?.id ?? "",
      });
    } else {
      setData(initialData);
    }
  }, [open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const handleFileChange = (e) => {
    setData({ ...data, picture: e.target.files[0] });
  };
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  const handleSave = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      if (data.password.length < 5) {
        dispatch(
          showSnackBar({
            text: t("drivers.thePasswordMustBeAt"),
            severity: "error",
          })
        );
        setLoading(false);
        return;
      }
      const emailValidated = validateEmail(data.email);
      if (!emailValidated) {
        dispatch(
          showSnackBar({
            text: t("drivers.invalidEmailAddress"),
            severity: "error",
          })
        );
        setLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append("username", data.username);
      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("start_time", data.start_time);
      formData.append("end_time", data.end_time);
      formData.append("vehicle", data.vehicle);
      formData.append("picture", data.picture);
      formData.append("password", data.password);
      const saved = await createNewDriver(formData);

      if (saved.error) {
        dispatch(
          showSnackBar({
            text: saved?.error?.response?.data?.email
              ? saved?.error?.response?.data?.email[0]
              : saved?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
            severity: "error",
          })
        );
        setLoading(false);
      } else {
        setRefresh(Math.floor(Math.random() * 100) + 1, saved);
        dispatch(
          showSnackBar({
            text: saved?.data?.message,
            severity: "success",
          })
        );
        setData(initialData);
        setConfirmPassword("");
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      dispatch(
        showSnackBar({
          text: error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        })
      );
      setLoading(false);
    }
  };

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("username", data.username);
      formData.append("name", data.name);
      formData.append("email", data.email);
      formData.append("phone", data.phone);
      formData.append("start_time", data.start_time);
      formData.append("end_time", data.end_time);
      formData.append("vehicle", data.vehicle);
      data.picture && formData.append("picture", data.picture);
      const saved = await editDriver(formData, data.id);
      if (saved.error) {
        dispatch(
          showSnackBar({
            text: saved?.error?.response?.data?.email
              ? saved?.error?.response?.data?.email[0]
              : saved?.error?.response?.data?.message || t("common:messages.somethingWentWrong"),
            severity: "error",
          })
        );
        setLoading(false);
      } else {
        setRefresh(Math.floor(Math.random() * 100) + 1);
        dispatch(
          showSnackBar({
            text: saved?.data?.message,
            severity: "success",
          })
        );
        setLoading(false);
        handleClose();
      }
    } catch (error) {
      dispatch(
        showSnackBar({
          text: error?.response?.data?.message || t("common:messages.somethingWentWrong"),
          severity: "error",
        })
      );
      setLoading(false);
    }
  };

  return (
    <div>
      <VehicleForm
        open={addVehicleModal}
        setOpen={setAddVehicleModal}
        setSnack={() => {}}
        setRefresh={() => {
          getAllVehicles("1", "100", "");
        }}
      />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        // onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Form onSubmit={open?.id ? handleUpdate : handleSave}>
          <div className="manage__driver_modal">
            <div className="manage__driver_modalheading">
              {open?.id ? t("drivers.updateDriver") : t("drivers.addDriver")}
            </div>
            <div className="manage__driver_modalcontent">
              <div className="manage__driver_modalrow">
                <div
                  className="manage__driver_modalinputwrap"
                  style={{ minWidth: "65%" }}
                >
                  <Form.Label>{t("drivers.fullName")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__driver_modalinput"
                    placeholder={t("drivers.fullName")}
                    name="name"
                    value={data.name}
                    onChange={handleChange}
                  />
                </div>
                <div className="manage__driver_modalinputwrap">
                  <Form.Label>{t("drivers.username")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__driver_modalinput"
                    placeholder={t("drivers.username")}
                    name="username"
                    value={data.username}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="manage__driver_modalrow">
                <div
                  className="manage__driver_modalinputwrap"
                  style={{ minWidth: "65%" }}
                >
                  <Form.Label>{t("drivers.email")}</Form.Label>
                  <Form.Control
                    required
                    className="manage__driver_modalinput"
                    placeholder={t("drivers.email")}
                    name="email"
                    value={data.email}
                    onChange={handleChange}
                    disabled={open?.id}
                  />
                </div>
                <div className="manage__driver_modalinputwrap">
                  <Form.Label>{t("drivers.phone")}</Form.Label>
                  <Form.Control
                    required
                    type="number"
                    className="manage__driver_modalinput"
                    placeholder={t("drivers.phone")}
                    name="phone"
                    value={data.phone}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="manage__driver_modalrow">
                <div className="manage__driver_modalinputwrap">
                  <Form.Label>{t("drivers.vehicle")}</Form.Label>
                  <div className="flex items-center">
                    <Autocomplete
                      sx={{
                        display: "inline-block",
                        width: "100%",
                      }}
                      onChange={(e, value) =>
                        setData({ ...data, vehicle: value.id })
                      }
                      id="custom-input-demo"
                      options={vehicles}
                      value={
                        data?.vehicle
                          ? vehicles.find((v) => v?.id === data?.vehicle) ||
                            null
                          : null
                      }
                      getOptionLabel={(option) =>
                        `${option.license_plate}, ${option.model}, ${option.type}`
                      }
                      renderInput={(params) => (
                        <div ref={params.InputProps.ref}>
                          <Form.Control
                            type="text"
                            {...params.inputProps}
                            // required
                            placeholder={t("drivers.vehicle")}
                            className="manage__driver_modalinput"
                            name="vehicle"
                          />
                        </div>
                      )}
                    />
                    <button
                      onClick={() => setAddVehicleModal(true)}
                      type="button"
                      className="p-2 ml-2 bg-brand text-white rounded-full hover:bg-brand-hover transition-all duration-150 shadow-soft-sm"
                    >
                      <FaPlus className="w-3.5 h-3.5" />
                    </button>
                  </div>
                </div>
              </div>

              <div className="manage__driver_modalrow">
                <div className="manage__driver_modallabel">{t("drivers.workTimeLabel")} </div>
                <div className="manage__driver_modalinputwrap">
                  <Form.Control
                    required
                    className="manage__driver_modalinput"
                    type="time"
                    value={data.start_time}
                    name="start_time"
                    onChange={handleChange}
                  />
                </div>
                <div className="manage__driver_modallabel2">{t("drivers.to")} </div>
                <div className="manage__driver_modalinputwrap">
                  <Form.Control
                    required
                    className="manage__driver_modalinput"
                    type="time"
                    name="end_time"
                    value={data.end_time}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="manage__driver_modalrow">
                <div className="manage__driver_modalinputwrap">
                  <Form.Label className="manage__driver_profimagelbl">
                    <Upload /> {data.picture?.name ?? t("drivers.uploadProfilePicture")}
                    <Form.Control
                      type="file"
                      size="60"
                      className="manage__driver_profimageinput"
                      onChange={handleFileChange}
                      accept=".jpg,.png"
                    />
                  </Form.Label>
                </div>
              </div>

              {!open?.id && (
                <div className="manage__driver_modalrow">
                  <div className="manage__driver_modalinputwrap">
                    <Form.Label>{t("drivers.password")}</Form.Label>
                    <Form.Control
                      required
                      className="manage__driver_modalinput"
                      placeholder={t("drivers.password")}
                      name="password"
                      value={data.password}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="manage__driver_modalinputwrap">
                    <Form.Label>{t("drivers.confirmPassword")}</Form.Label>
                    <Form.Control
                      required
                      className="manage__driver_modalinput"
                      placeholder={t("drivers.confirmPassword")}
                      name="confirmPassword"
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      isInvalid={data.password != confirmPassword}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="manage__driver_modalfooter">
              <div className="manage__driver_modalcncl" onClick={handleClose}>
                {t("common:actions.cancel")}
              </div>
              <Button
                className="manage__driver_modalsave"
                disabled={
                  loading ||
                  (open?.id ? false : data.password != confirmPassword)
                }
                type="submit"
              >
                {loading ? <Loader /> : t("common:actions.save")}
              </Button>
            </div>
          </div>
        </Form>
      </Modal>
    </div>
  );
}
